import React, { useState } from "react";
import { DeleteFilled } from "@ant-design/icons";
import { addFileLettreMissionClient } from "../../../../data/file";
import swal from "sweetalert";
import * as Yup from "yup";
import { ModalTitle } from "../../../modals/modals.components";
import { Form, Formik } from "formik";
import { Button, Col, Input, Row } from "antd";
import FormLabel from "../../../common/Form/FormLabel";
import { getIconForFileType } from "../../../layout/menu/CustomMenu";
import FormError from "../../../common/Form/FormError";
import ModalAlert from "../../../modals/Modal";

const FileUploadLettreMissionSigne = ({
  handleVisibility,
  exercice,
  visible,
  fetchData,
  codeSommaire,
  date,
  heureEntree,
  tache_id,
  user_id,
  intervention_id,
}) => {
  const [loadingCreate, setLoadingCreate] = useState(false);
  const handleUploadAll = async (value) => {
    const fileSizeLimit = 10 * 1024 * 1024;
    for (const file of value.selectedFiles) {
      if (file.size <= fileSizeLimit) {
        const extension = file.name.split(".").pop().toLowerCase();

        const formData = new FormData();
        formData.append("file", file);
        formData.append("reference", value.reference);
        formData.append("libelle", value.libelle);
        formData.append("description", value.description);
        formData.append("size", file.size);
        formData.append("extension", extension);
        formData.append("exercice_id", exercice.id);
        formData.append("client_id", exercice.client_id);
        formData.append("codeSommaire", codeSommaire);
        formData.append("intervention_id", intervention_id);
        formData.append("date", date);
        formData.append("heureEntree", heureEntree);
        formData.append("tache_id", tache_id);
        formData.append("user_id", user_id);

        const response = await addFileLettreMissionClient(formData);
        if (response.status === "success") {
          await swal("Opération effectuée avec succès", "", "success");
          fetchData(exercice.id);
          handleVisibility();
          setLoadingCreate(false);
        } else {
          await swal(
            response.message || "Error d'importation du fichier",
            "",
            "error"
          );
          setLoadingCreate(false);
        }
      } else {
        await swal("File size exceeds the limit", "", "error");
      }
    }
  };

  const dataValidationScheme = Yup.object({
    mission_id: Yup.number()
      .required("Veuillez sélectionner la mission")
      .nullable("Le mission est obligatoire")
      .typeError("Le mission est obligatoire"),
    // libelle: Yup.string().required("Le nom du fichier est obligatoire"),
  });

  // console.log("mission", exercice)

  return (
    <>
      <ModalAlert
        closeModal={handleVisibility}
        show={visible}
        title={
          <ModalTitle>
            {" "}
            Joindre la lettre de mission{" "}
            {exercice
              ? ` a ${exercice.mission || ""} - ${exercice.annee || ""}`
              : ""}
          </ModalTitle>
        }
        footer={[]}
        modalStyles={{ top: 30 }}
        width={600}
      >
        <Formik
          initialValues={{
            selectedFiles: [],
            codeSommaire: "",
            reference: `${codeSommaire}-XXX` || "",
            libelle: `LETTRE MISSION ${exercice.mission} - ${exercice.annee}`,
            description: "",
            client_id: (exercice && exercice.client_id) || "",
            mission_id: (exercice && exercice.id) || "",
          }}
          onSubmit={(values) => handleUploadAll(values)}
          validationSchema={dataValidationScheme}
        >
          {({ values, handleSubmit, setFieldValue, touched, errors }) => (
            <Form>
              <Row gutter={[16, 16]}>
                <Col span={20}>
                  <FormLabel label="Fichier" required />
                  <div className="row fv-row mb-7 fv-plugins-icon-container">
                    <div className="d-flex align-center">
                      <div className="">
                        <div className="d-flex align-items-center mb-3">
                          <input
                            type="file"
                            style={{ width: "100%" }}
                            className="form-control w-lg-400px"
                            // accept=".xlsx, .csv, .xls"
                            onChange={(value) => {
                              const files = value.target.files;
                              const fileSizeLimit = 10 * 1024 * 1024;
                              const validFiles = Array.from(files).filter(
                                (file) => file.size <= fileSizeLimit
                              );
                              setFieldValue("selectedFiles", [
                                ...values.selectedFiles,
                                ...validFiles,
                              ]);
                            }}
                            required={true}
                          />
                        </div>
                        <span className="form-text fs-6 text-muted">
                          Taille maximale de fichier 10MB.
                        </span>
                      </div>
                    </div>

                    <div className="dropzone-items">
                      {/* Show the list of selected files */}
                      {values.selectedFiles.map((file, index) => (
                        <div key={index} className="m-6">
                          {getIconForFileType(file.name)} {file.name}
                        </div>
                      ))}
                    </div>
                  </div>
                  {touched.selectedFiles && errors.selectedFiles && (
                    <FormError fieldName="selectedFiles" />
                  )}
                </Col>
                <Col span={4}>
                  <div className="pt-10">
                    <button
                      className="dropzone-remove-all btn btn-sm btn-light-primary"
                      onClick={() => {
                        setFieldValue("selectedFiles", []);
                      }}
                    >
                      <DeleteFilled
                        style={{ color: "red", fontSize: "15px" }}
                      />
                    </button>
                  </div>
                </Col>
                <Col span={24}>
                  <FormLabel label="Reférence" />
                  <Input
                    size="large"
                    placeholder={`${codeSommaire}-XXX`}
                    name="reference"
                    value={values.reference}
                    onChange={(e) => setFieldValue("reference", e.target.value)}
                  />
                  {touched.reference && errors.reference && (
                    <FormError fieldName="reference" />
                  )}
                </Col>
                <Col span={24}>
                  <FormLabel label="Nom du fichier" required />
                  <Input
                    size="large"
                    placeholder="Le nom du fichier"
                    name="libelle"
                    value={values.libelle}
                    onChange={(e) => setFieldValue("libelle", e.target.value)}
                  />
                  {touched.libelle && errors.libelle && (
                    <FormError fieldName="libelle" />
                  )}
                </Col>
                <Col span={24}>
                  <FormLabel label="Note" />
                  <Input.TextArea
                    size="large"
                    placeholder="Notes..."
                    name="description"
                    value={values.description}
                    onChange={(e) =>
                      setFieldValue("description", e.target.value)
                    }
                    showCount
                    maxLength={3000}
                    rows={2}
                  />
                  {touched.description && errors.description && (
                    <FormError fieldName="description" />
                  )}
                </Col>
                <Col span={24}>
                  <Button
                    type="primary"
                    block
                    size="large"
                    loading={loadingCreate}
                    disabled={loadingCreate}
                    onClick={handleSubmit}
                  >
                    {!loadingCreate && (
                      <span className="indicator-label">Enregistrer</span>
                    )}
                    {loadingCreate && (
                      <span className="indicator-progress text-white">
                        Veuillez patienter...
                        <span className="spinner-border spinner-border-sm align-middle ms-2 text-white"></span>
                      </span>
                    )}
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </ModalAlert>
    </>
  );
};
export default FileUploadLettreMissionSigne;
